import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import usePlayerTrucLoc from "../../hooks/usePlayerTrucLoc";
import usePlayerConfig from "../../hooks/usePlayerConfig";
import { postStopTrucLoc, startTrucLoc } from "../../services/authService";
import { IDLE_TIMEOUT, OPTION_SELECT_TRUC_LOC_COMBAT_COUNT, PLAYER_CONFIG, PLAYER_CONFIG_LABEL, PLAYER_CONFIG_TIP } from "../../constants/Common";
import { TOAST_TYPE, updateToastPromise } from "../../contexts/ToastProvider";
import { DONE_AUTO_TRUC_LOC, ERROR_START_TRUC_LOC, RUNING_AUTO_TRUC_LOC } from "../../constants/errMessage";
import { toast } from "react-toastify";
import MoleculeSingleSelectBoxWithCreatable from "../../Molecule/MoleculeSingleSelectBoxWithCreatable";
const PlayerTrucLoc = ({ playerId }) => {
    const { trucLoc } = usePlayerTrucLoc(playerId);
    const { configs, updateSingleConfig } = usePlayerConfig(playerId);
    const [countCombat, setCountCombat] = useState(0);
    const [idTimer, setIdTimer] = useState(null);
    const [isRuning, setIsRuning] = useState(false);
    const [toastPromiseId, setToastPromiseId] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const [localTrucLoc, setLocalTrucLoc] = useState({
        configCount: 0,
        isRuning: false,
        count: 0,
        matchNum: 0,
        winNum: 0,
        score: 0
    })

    const groupOptions = [
        OPTION_SELECT_TRUC_LOC_COMBAT_COUNT,
    ]

    const handleChangeSelect = (selectOption) => {
        // console.log('handleChangeSelect', selectOption)
        setSelectedOption(selectOption);
        if (selectOption == null) {
            setCountCombat(0);
            setSelectedOption(OPTION_SELECT_TRUC_LOC_COMBAT_COUNT.options[0])
        } else {
            setCountCombat(selectOption.value)
        }
    }

    const handleStartTrucLoc = (e) => {
        e.preventDefault();
        setTimeoutRuning();
        startTrucLoc(playerId, countCombat).then((res) => {
            // console.log('handleStartTrucLoc', res.error)
            if (res.error === true) {
                clearStatusRunningTrucLoc();
            }
        }).catch((error) => {
            setIsRuning(false);
        });
    }

    const handleStopTrucLoc = () => {
        postStopTrucLoc(playerId);
    }

    const messageOfRuningTrucLoc = () => {
        const message = `${RUNING_AUTO_TRUC_LOC}Trận đấu thứ ${localTrucLoc?.matchNum ?? 0}, Thắng ${localTrucLoc?.winNum ?? 0}, Điểm: ${localTrucLoc?.score ?? 0}`
        return message
    }

    const setShowToast = (type) => {
        switch (type) {
            case TOAST_TYPE.LOADING:
                if (toastPromiseId == null) {
                    const idLoading = toast.loading(messageOfRuningTrucLoc());
                    setToastPromiseId(idLoading);
                } else {
                    updateToastPromise(toastPromiseId, messageOfRuningTrucLoc(), TOAST_TYPE.INFO)
                }
                break;
            case TOAST_TYPE.ERROR:
                if (toastPromiseId == null) toast.error(ERROR_START_TRUC_LOC);
                else updateToastPromise(toastPromiseId, ERROR_START_TRUC_LOC, TOAST_TYPE.ERROR);
                setToastPromiseId(null);
                break;
            default:
                if (toastPromiseId == null) toast.success(DONE_AUTO_TRUC_LOC)
                else updateToastPromise(toastPromiseId, DONE_AUTO_TRUC_LOC, TOAST_TYPE.SUCCESS)
                setToastPromiseId(null);
                break;
        }
    }

    const setTimeoutRuning = () => {
        clearTimeout(idTimer);
        setIsRuning(true);
        const idtimeout = setTimeout(() => {
            clearStatusRunningTrucLoc();
            setShowToast(TOAST_TYPE.SUCCESS);
        }, IDLE_TIMEOUT.CLEAR_STATUS_AUTO_TRUC_LOC);
        setIdTimer(idtimeout);
    }
    const clearStatusRunningTrucLoc = () => {
        clearTimeout(idTimer);
        setIsRuning(false);
    }

    useEffect(() => {
        if (configs != null && configs[PLAYER_CONFIG.ID_TOURNAMENT_DAILY_LIMIT] != countCombat) {
            setCountCombat(configs[PLAYER_CONFIG.ID_TOURNAMENT_DAILY_LIMIT])
            setSelectedOption({ value: configs[PLAYER_CONFIG.ID_TOURNAMENT_DAILY_LIMIT], label: configs[PLAYER_CONFIG.ID_TOURNAMENT_DAILY_LIMIT] })
            // console.log('useEffect', { value: configs[PLAYER_CONFIG.ID_TOURNAMENT_DAILY_LIMIT], label: configs[PLAYER_CONFIG.ID_TOURNAMENT_DAILY_LIMIT] })
        }
    }, [configs])

    useEffect(() => {
        if (trucLoc == null || trucLoc.isRuning == null) return;
        if (trucLoc.isRuning) {
            setTimeoutRuning();
            setShowToast(TOAST_TYPE.LOADING);
        } else if (trucLoc.isRuning != isRuning) {
            // console.log(trucLoc, isRuning);
            clearStatusRunningTrucLoc();
            setShowToast(TOAST_TYPE.SUCCESS);
        }
        setLocalTrucLoc({ ...trucLoc })
    }, [trucLoc])

    return (
        <Row>
            <Form onSubmit={(e) => { handleStartTrucLoc(e); }}>
                <Row className="mt-1" >
                    <Col className="ps-2">
                        <Row xs={1} sm={1} md={2} lg={3}>
                            <MoleculeSingleSelectBoxWithCreatable
                                label={PLAYER_CONFIG_LABEL[PLAYER_CONFIG.ID_TOURNAMENT_DAILY_LIMIT]}
                                options={groupOptions}
                                placeholder={''}
                                tooltip={PLAYER_CONFIG_TIP[PLAYER_CONFIG.ID_TOURNAMENT_DAILY_LIMIT]}
                                value={selectedOption}
                                onChange={(selectOption) => { handleChangeSelect(selectOption) }}
                                key={PLAYER_CONFIG.ID_TOURNAMENT_DAILY_LIMIT}
                            ></MoleculeSingleSelectBoxWithCreatable>
                        </Row>
                        {localTrucLoc != null && localTrucLoc.isRuning != null &&
                            <Row className="mt-1">
                                <Col className="d-none d-lg-block d-sm-block d-md-block">
                                    <Row className="h5 text-info align-items-center text-nowrap d-flex justify-content-start">
                                        <Col xs="auto"><span>Tổng Trận</span></Col>
                                    </Row>
                                    <Row className="align-items-center d-flex justify-content-start">
                                        <Col xs="auto">
                                            <span>{localTrucLoc.matchNum}</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className="h5 text-info align-items-center text-nowrap d-flex justify-content-center">
                                        <Col xs="auto"><span>Thắng</span></Col>
                                    </Row>
                                    <Row className="align-items-center text-nowrap d-flex justify-content-center">
                                        <Col xs="auto">
                                            <span>{localTrucLoc.winNum}</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className="h5 text-info align-items-center text-nowrap d-flex justify-content-center">
                                        <Col xs="auto"><span>Điểm</span></Col>
                                    </Row>
                                    <Row className="align-items-center text-nowrap d-flex justify-content-center">
                                        <Col xs="auto">
                                            <span>{localTrucLoc.score}</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className="h5 text-info align-items-center text-nowrap d-flex justify-content-center">
                                        <Col xs="auto"><span>Lượt</span></Col>
                                    </Row>
                                    <Row className="align-items-center text-nowrap d-flex justify-content-center">
                                        <Col xs="auto">
                                            <span>{localTrucLoc.count}</span>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        }
                    </Col>
                    <Col xs={3} sm={2} md={2} lg={2} className="d-flex align-items-center">
                        {!isRuning && <Button className="mx-auto" variant="success" type="submit">Start</Button>}
                        {isRuning && <Button className="mx-auto" variant="danger" onClick={() => { handleStopTrucLoc() }}>Dừng</Button>}
                    </Col>
                </Row>
            </Form>
        </Row>

    );
}

export default PlayerTrucLoc
